<template>
  <div>
    <BaseFormPaymentMethod
      :initialState="state"
      :state.sync="sync.state"
      :form.sync="sync.$formPayment"
      :onReset.sync="sync.onReset"
      :isSubmitted="isSubmitted"
    />

    <BaseFormAction
      :textCancel="$t('button.cancel')"
      :textSubmit="$t('button.save')"
      :isSubmitted="isSubmitted"
      :isHideCloseButton="true"
      @onCancel="handleCancel"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
export default {
  props: {
    state: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    isSubmitted: {
      required: true,
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      sync: {
        state: {},
        $formPayment: null,
        onReset: null,
      },
    }
  },

  watch: {
    sync: {
      handler: function () {
        this.$emit('update:form', this.sync)
      },
      deep: true,
    },
  },

  methods: {
    handleCancel () {
      if (this.$listeners.onCancel) {
        this.$emit('onCancel')
      } else {
        this.sync.onReset()
        this.scrollToTop(600)
      }
    },
    handleSubmit () {
      this.sync.$formPayment.$touch()
      if (this.sync.$formPayment.$invalid) {
        this.scrollToTop(600)
      } else {
        this.$emit('onSubmit', this.sync.state)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/BillingPaymentMethodForm.vue